export default __webpack_public_path__ + "static/media/divine_body_from_guyun.4c458b26.png";